import { Host, h } from "@stencil/core";
import state from "../store";
export class GxgLabel {
    constructor() {
        this.labelPosition = "start";
        this.disabled = false;
        this.noMargin = false;
        this.center = undefined;
        this.for = undefined;
        this.width = "auto";
        this.tooltip = undefined;
    }
    componentWillLoad() {
        if ((this.center === undefined && this.labelPosition === "start") ||
            (this.center === undefined && this.labelPosition === "end")) {
            this.center = true;
        }
    }
    render() {
        return (h(Host, { class: {
                large: state.large,
                "gxg-label--no-margin": this.noMargin,
                "gxg-label--center": this.center,
                [`position-${this.labelPosition}`]: true,
            }, style: {
                width: this.width,
            } }, h("label", { htmlFor: this.for }, this.tooltip ? (h("gxg-tooltip", { label: this.tooltip }, h("slot", null))) : null, h("slot", null))));
    }
    static get is() { return "gxg-label"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["gxg-label.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["gxg-label.css"]
        };
    }
    static get properties() {
        return {
            "labelPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "LabelPosition",
                    "resolved": "\"above\" | \"below\" | \"end\" | \"start\"",
                    "references": {
                        "LabelPosition": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::LabelPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "*******************************\nPROPERTIES & STATE\n*******************************"
                },
                "attribute": "label-position",
                "reflect": false,
                "defaultValue": "\"start\""
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "disabled",
                "reflect": true,
                "defaultValue": "false"
            },
            "noMargin": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "no-margin",
                "reflect": false,
                "defaultValue": "false"
            },
            "center": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "center",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "for": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "for",
                "reflect": false
            },
            "width": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "width",
                "reflect": false,
                "defaultValue": "\"auto\""
            },
            "tooltip": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "tooltip",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=gxg-label.js.map
